module.exports = __webpack_public_path__ + "hbomaxar-static/media/witches.509af278.mp4";